import ChipColors from './ChipColors';

export default [
  {
    value: 'ContaCard',
    text: 'Cardmais',
    ...ChipColors.warning,
  },
  {
    value: 'CardBackOffice',
    text: 'Backoffice',
    ...ChipColors.wait,
  },
  {
    value: 'CardMobile',
    text: 'Card mobile',
    ...ChipColors.danger,
  },
  {
    value: 'CardHub',
    text: 'Cardhub',
    ...ChipColors.neutral,
  },
];
